import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Chiave del token di sessione salvato in locale come FALLBACK resiliente:
// su alcuni browser mobile (Safari/iOS ITP, PWA in standalone) i cookie httpOnly
// possono essere eliminati; il token in localStorage permette di restare autenticati
// finché è valido. Il backend accetta sia il cookie sia l'header Bearer.
export const TOKEN_KEY = "hi_token";
export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
};
export const setToken = (t) => {
  try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch { /* storage non disponibile */ }
};
export const clearToken = () => setToken(null);

const api = axios.create({ baseURL: API, withCredentials: true });

// Allega il token Bearer (se presente) ad ogni richiesta: doppio canale con il cookie.
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    // `/auth/me` è solo una sonda di sessione: un 401 qui significa "anonimo",
    // non deve forzare un redirect (gestito da AuthContext).
    const isProbe = url.endsWith("/auth/me");
    const status = err?.response?.status;
    // Nessuna risposta => problema di rete/connessione: NON disconnettere né redirigere,
    // lascia gestire l'errore al chiamante (messaggio chiaro all'utente).
    if (status === 401 && !isProbe) {
      // Sessione realmente scaduta/assente: pulisci il token locale e riporta al login,
      // evitando loop se già sulla pagina di login.
      clearToken();
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
